<template>
  <section class="select-demand-severity">
    <HSelect
      id="demand-severity"
      :options="options"
      :value="selected"
      label="Situação"
      class="select-demand-severity__select"
      name="demand-severity"
      option-key="label"
      option-label="label"
      @update:value="handleSelectSeverity"
    >
      <template #iconLeft>
        <span
          class="select-demand-severity__select__marker"
          :class="selectedSeverity"
        />
      </template>
    </HSelect>
  </section>
</template>

<script>
import {
  CONDITION_SEVERITY_OPTIONS,
  DEMAND_TYPES,
  GOAL_SEVERITY_OPTIONS
} from '@/models/demands'
import Logger, { EventModel, EventName } from '@/wrappers/logger'

import { HSelect } from '../../atoms'

export default {
  name: 'SelectDemandSeverity',
  components: { HSelect },
  props: {
    demand: {
      type: Object,
      required: true
    }
  },
  emits: ['input'],
  computed: {
    selected() {
      return this.options.find(option => option.value === this.demand.severity)
    },
    options() {
      return this.demand.description.type === DEMAND_TYPES.GOAL
        ? GOAL_SEVERITY_OPTIONS
        : CONDITION_SEVERITY_OPTIONS
    },
    selectedSeverity() {
      return this.selected?.value
    }
  },
  methods: {
    handleSelectSeverity({ value }) {
      Logger.addLog(EventName.USER_INTERACTION_FORM, {
        model: EventModel.APPOINTMENT,
        data: {
          context: 'add-demand-widget',
          action: 'select-severity'
        }
      })
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-demand-severity {
  &__select {
    &__marker {
      border-radius: var(--gl-border-radius-pill);
      display: block;
      height: 10px;
      width: 10px;

      &.PAUSED,
      &.DECOMPENSATED {
        background-color: var(--gl-color-shades-yellow-60);
      }

      &.ONGOING,
      &.COMPENSATED {
        background-color: var(--gl-color-shades-green-90);
      }

      &.DONE,
      &.INACTIVE {
        background-color: var(--gl-color-shades-gray-50);
      }
    }
  }
}
</style>
